import { render, staticRenderFns } from "./ed-create-c-material-sections.vue?vue&type=template&id=dd54f720&scoped=true&"
import script from "./ed-create-c-material-sections.ts?vue&type=script&lang=ts&"
export * from "./ed-create-c-material-sections.ts?vue&type=script&lang=ts&"
import style0 from "./ed-create-c-material-sections.scss?vue&type=style&index=0&id=dd54f720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd54f720",
  null
  
)

export default component.exports